export enum Cookie {
  ID_PAGO = '_suraenlinea_id-pago_',
  ESTADO_PAGO = '_suraenlinea_estado-pago_',
  TIEMPO_EXPIRACION_EN_MINUTOS = 20,
  DONE = 'done',
  START = 'START',
}
